import { type DataFromRFID, fromRFID } from 'maps/services/dto/fromRFID'
import type { Store } from 'maps/types'
import { fetcher } from 'services/rest/fetcher'
import { env } from 'utils/envManager'

export type GetStoresRFIDParams = {
	readonly productId: string
	readonly colorId: string
	readonly country: string
	readonly language: string
	readonly latitude?: string
	readonly longitude?: string
}

export async function getStoresRFID({
	productId,
	colorId,
	country,
	language,
	latitude,
	longitude,
}: GetStoresRFIDParams): Promise<Store[]> {
	const url = new URL(
		'/ws/0/store-finder/v1/stores/stock',
		env.NEXT_PUBLIC_API_DOMAIN
	)

	url.search = new URLSearchParams({
		colorId,
		productId,
		country: country.toUpperCase(),
		language: language.toUpperCase(),
		channel: env.NEXT_PUBLIC_CHANNEL,
		latitude: latitude ?? '0.0',
		longitude: longitude ?? '0.0',
	}).toString()

	const { stores } = await fetcher<{ stores: DataFromRFID[] }>(url.href)

	return stores.map(fromRFID)
}
